import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Box, ButtonVariant, Heading, HeadingAlignment, HeadingType, InteractiveImage, LinkTarget, Text, TextAlign, TextSize, } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { getPictureSrcset } from '../../util/ImageUtil';
import { MiniPDPContainer } from '../../containers/MiniPDPContainer';
import ProductsAPI from '../../api/ProductsAPI';
import ProductDetailAPI from '../../api/ProductDetailAPI';
import { fixProductColoursFallback, mergeProductPricesToProductLister } from '@as-react/common-utils';
const ProductInspiration = ({ title, subTitle, image, buttons, deliveryPromiseExplanations, cdnSettings, }) => {
    const { defaultRequestParams, servicesEndpoint, imageCdnPrefix } = useAemConfig();
    const [miniPDPProduct, setMiniPDPProduct] = useState(null);
    const [activeMarker, setActiveMarker] = useState(null);
    const srcset = getPictureSrcset({ imagePath: image.imagePath, renditions: image.renditions, lastModified: image.lastModified }, imageCdnPrefix, cdnSettings === null || cdnSettings === void 0 ? void 0 : cdnSettings.imageQuality, cdnSettings === null || cdnSettings === void 0 ? void 0 : cdnSettings.requestPassThrough);
    const getRenditionIdFromClickMapKey = (clickMapKey) => clickMapKey.substring(clickMapKey.lastIndexOf('/') + 1);
    const onClickMarker = (marker) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const hasProductFallback = !!marker.productFallback && !!marker.productFallback.id && !!marker.productFallback.color;
            const fallbackProducts = hasProductFallback
                ? [
                    {
                        productCode: marker.productFallback.id,
                        productColor: marker.productFallback.color,
                    },
                ]
                : null;
            const result = yield ProductsAPI.getSingleProductData(servicesEndpoint, defaultRequestParams.mainWebshop, defaultRequestParams.anaLang, defaultRequestParams.language, defaultRequestParams.shopId, marker.product.id, marker.product.color, fallbackProducts, true);
            if (result) {
                const product = hasProductFallback ? fixProductColoursFallback(result) : result;
                const productPrice = yield ProductDetailAPI.getProductDetailPriceByProductId(servicesEndpoint, defaultRequestParams.mainWebshop, defaultRequestParams.shopId, product.productId);
                const mergedProduct = mergeProductPricesToProductLister(product, productPrice);
                setActiveMarker(marker.markerId);
                setMiniPDPProduct(mergedProduct);
            }
        }
        catch (_a) { }
    });
    const maps = image.clickMaps
        ? Object.keys(image.clickMaps).map(clickMapKey => ({
            renditionId: getRenditionIdFromClickMapKey(clickMapKey),
            points: image.clickMaps[clickMapKey].map(marker => ({
                id: marker.markerId.toString(),
                x: marker.point.x,
                y: marker.point.y,
                onClick: () => onClickMarker(marker),
                isActive: marker.markerId === activeMarker,
            })),
        }))
        : null;
    const mappedButtons = buttons
        ? buttons.map(button => {
            const variantKey = Object.keys(ButtonVariant).find(key => {
                return ButtonVariant[key].toLowerCase() === button.variant.toLowerCase();
            });
            return {
                text: button.label,
                title: button.alt,
                variant: ButtonVariant[variantKey],
                href: button.href,
                target: button.target ? LinkTarget.BLANK : null,
                iconLeft: button.iconLeft
                    ? {
                        name: button.iconLeft,
                    }
                    : undefined,
                iconRight: button.iconRight
                    ? {
                        name: button.iconRight,
                    }
                    : undefined,
            };
        })
        : null;
    const handleMiniPDPClose = () => {
        setActiveMarker(null);
        setMiniPDPProduct(null);
    };
    return (_jsxs(_Fragment, { children: [!!title && (_jsx(Heading, { type: HeadingType.TITLE, alignment: HeadingAlignment.CENTER, children: title })), !!subTitle && (_jsx(Text, { size: TextSize.SMALL, align: TextAlign.CENTER, children: subTitle })), _jsx(Box, { mobile: title && subTitle ? { spacing: { marginTop: 3 } } : null, children: _jsx(InteractiveImage, { image: {
                        src: image.imagePath,
                        srcset: srcset,
                        lazy: image.lazy,
                    }, maps: maps, buttons: mappedButtons }) }), _jsx(MiniPDPContainer, { displayPackShotImagesFirst: true, productCode: miniPDPProduct === null || miniPDPProduct === void 0 ? void 0 : miniPDPProduct.productCode, colorId: miniPDPProduct === null || miniPDPProduct === void 0 ? void 0 : miniPDPProduct.colourId, deliveryPromiseExplanations: deliveryPromiseExplanations, onClose: handleMiniPDPClose })] }));
};
export default ProductInspiration;
